import React, { useState, useRef, useEffect } from 'react';
import { User, ChevronDown } from 'lucide-react';

export default function AccountDropdown({ onSignOut, onShowUserInfo }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleUserInfoClick = () => {
    setIsOpen(false);
    onShowUserInfo();
  };

  const handleSignOutClick = () => {
    setIsOpen(false);
    onSignOut();
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        className="flex h-9 items-center gap-1.5 rounded-lg border border-line bg-surface px-3 text-ink-muted shadow-sm transition-colors hover:bg-surface-alt hover:text-ink"
      >
        <User className="h-4 w-4" />
        <ChevronDown className="h-3.5 w-3.5" />
      </button>

      {isOpen && (
        <div
          role="menu"
          className="absolute right-0 z-50 mt-2 w-48 overflow-hidden rounded-xl border border-line bg-surface py-1 shadow-lift animate-scale-in"
        >
          <button
            onClick={handleUserInfoClick}
            role="menuitem"
            className="block w-full px-4 py-2 text-left text-sm text-ink-muted transition-colors hover:bg-surface-alt hover:text-ink"
          >
            User Info
          </button>
          <button
            onClick={handleSignOutClick}
            role="menuitem"
            className="block w-full px-4 py-2 text-left text-sm text-ink-muted transition-colors hover:bg-surface-alt hover:text-ink"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}
